var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDelete(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 16,
    viewBox: "0 0 14 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "delete",
    transform: "translate(-9 -4.5)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14034",
    "data-name": "Group 14034",
    transform: "translate(9 4.5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_13170",
    "data-name": "Path 13170",
    d: "M27,27h1.167v6.857H27Z",
    transform: "translate(-22.333 -21.286)",
    fill: "#ababab"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13171",
    "data-name": "Path 13171",
    d: "M40.5,27h1.167v6.857H40.5Z",
    transform: "translate(-32.333 -21.286)",
    fill: "#ababab"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13172",
    "data-name": "Path 13172",
    d: "M9,13.5v1.143h1.167V26.071a1.155,1.155,0,0,0,1.167,1.143h9.333a1.155,1.155,0,0,0,1.167-1.143V14.643H23V13.5Zm2.333,12.571V14.643h9.333V26.071Z",
    transform: "translate(-9 -11.214)",
    fill: "#ababab"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13173",
    "data-name": "Path 13173",
    d: "M27,4.5h4.667V5.643H27Z",
    transform: "translate(-22.333 -4.5)",
    fill: "#ababab"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelete);
export default __webpack_public_path__ + "static/media/delete.078bac50e6c6b05de762c9ebe09a76ec.svg";
export { ForwardRef as ReactComponent };